var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mita"},[_c('a',{attrs:{"href":_vm.mitaClubPagePath}},[_c('img',{staticClass:"mitaclub-banner",attrs:{"src":_vm.imgPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }